import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const fieldConfigurationRoutes = [
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/Field-Configuration/update/:id',
	},
];

export default fieldConfigurationRoutes;
